import { useLingui } from '@lingui/react/macro'
import { createFileRoute } from '@tanstack/react-router'
import { IconLanguageOutline18, IconPaletteOutline18 } from 'nucleo-ui-outline-18'
import { SettingsPage, SettingsRow, SettingsSection } from '~/components/settings/settings-page'
import { ThemePicker } from '~/components/settings/theme-picker'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '~/components/ui/select'
import { useLocale } from '~/lib/locale-store'
import { LOCALE_LABELS, LOCALES } from '~/lib/locales'

export const Route = createFileRoute('/_authenticated/$workspaceSlug/account/appearance')({
  component: AppearanceSettings,
})

/**
 * Theme and language. Both are client-side preferences held by `useTheme` /
 * `useLocale`, so there is nothing to save — the pickers apply immediately,
 * and the icon rail's quick switchers read the same state.
 */
function AppearanceSettings() {
  const { t } = useLingui()
  const { locale, setLocale } = useLocale()

  return (
    <SettingsPage>
      <SettingsSection
        description={t`System follows whatever your device is set to, and switches with it.`}
        icon={IconPaletteOutline18}
        title={t`Theme`}
      >
        <div className="p-4">
          <ThemePicker />
        </div>
      </SettingsSection>

      <SettingsSection icon={IconLanguageOutline18} title={t`Language`}>
        <SettingsRow label={t`Interface language`}>
          {/* Supply labels so SelectValue does not render raw locale codes. */}
          <Select
            items={LOCALE_LABELS}
            onValueChange={(value) => setLocale(value as (typeof LOCALES)[number])}
            value={locale}
          >
            <SelectTrigger aria-label={t`Language`} className="w-full">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {LOCALES.map((value) => (
                <SelectItem key={value} value={value}>
                  {LOCALE_LABELS[value]}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </SettingsRow>
      </SettingsSection>
    </SettingsPage>
  )
}
